import HTMLReactParser from './index.js';

export default HTMLReactParser;
export const { domToReact, htmlToDOM, attributesToProps } = HTMLReactParser;
